import { useSite } from '@unisporkal/sites';
import { getSiteConfig, SiteConfig } from './site';

const useSiteConfig = (): SiteConfig => {
  const site = useSite();
  const siteConfig = getSiteConfig(site.nickname);

  return siteConfig;
};

export default useSiteConfig;
